const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export function getState(state) {
  switch (state) {
    case "created":
      return "Meldung abgegeben";
    case "in progress":
      return "Meldung in Bearbeitung";
    case "successfull":
      return "Meldung abgeschlossen (erfolgreich)";
    case "failed":
      return "Meldung abgeschlossen (nicht erfolgreich)";
    default:
      return "---";
  }
}

export function getKisDefectWidgetHTML(apiKey) {
  const innerHTML = `<div id="eokis-defect-widget" class="eokis-defect-widget"
     data-api-key="${apiKey.apiKey}"
     data-api-url="${env.kis_api_client_url}"
     data-form-name="${apiKey.dataFormName}"
     data-color-text="${apiKey.color["color-text"]}"
     data-color-primary="${apiKey.color["color-primary"]}"
     ></div>

<div class="eokis-defect-async-scripts" data-path="${env.kis_defect_widget_api_url}">
    <div data-name="eokis-defect-defectWidget"></div>
</div>

<script type="module" src="${env.kis_defect_widget_api_url}loadAsyncKisDefect.min.js"></script>
<link href="${env.kis_defect_widget_api_url}eokis-defect-Variables.css" rel="stylesheet" type="text/css">`;
  return innerHTML;
}
